export default {"src":"/_next/static/image/public/images/flags/flag_51.5f66a72786587bbb3ae1287179f210de.svg","height":16,"width":24};